import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

export default function useBlocker(shouldBlock) {
  const navigate = useNavigate();
  const isBlocking = useRef(false);

  useEffect(() => {
    if (!shouldBlock) return;

    // Push a state to the history stack to intercept back button
    window.history.pushState({ preventBack: true }, '', window.location.href);
    isBlocking.current = true;

    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    const handlePopState = async (event) => {
      if (!isBlocking.current) return;
      
      // Push state again to prevent navigation
      window.history.pushState({ preventBack: true }, '', window.location.href);
      
      // Show confirmation dialog using SweetAlert2
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to go back? Unsaved data may be lost.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, go back',
        cancelButtonText: 'Cancel'
      });

      if (result.isConfirmed) {
        // User confirmed, allow navigation
        isBlocking.current = false;
        window.history.back();
      }
      // If cancelled, we stay on the page (state already pushed)
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      isBlocking.current = false;
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [shouldBlock, navigate]);
}
